import React, { PropsWithChildren } from 'react';
import { InspectionContextType, InspectionProviderProps } from './types';
import { useOne } from 'app/definitions/hooks/data/useOne';
import { Inspection, InspectionReportProgress } from '../../types';
import { GetOneResponse } from 'app/context/data/types';
import { Spin } from 'antd';
import { useList } from 'app/definitions';

const InspectionContext = React.createContext<InspectionContextType>({
  inspection: {} as any,
  progress: {} as any,
  report: {} as any
});

const InspectionProvider: React.FC<
  PropsWithChildren<InspectionProviderProps>
> = ({ children, id }) => {
  const queryProgress = useList<InspectionReportProgress>({
    resource: 'inspections/:id/progress',
    meta: {
      id: id
    },
    queryOption: {
      skip: !id
    }
  });

  const query = useOne<Inspection>({
    resource: 'admin/inspections',
    id,
    queryOptions: {
      skip: !id,
      selectFromResult: (result) => {
        if (result && result?.data) {
          return {
            ...result,
            data: result?.data?.data
          };
        }
        return result as unknown as GetOneResponse<Inspection>;
      }
    }
  });

  const queryReport = useList({
    resource: '/admin/inspections/:id/report',
    meta: {
      id: id
    },
    queryOption: {
      skip: !id
    }
  });

  const loading = React.useMemo(
    () =>
      query.isLoading ||
      query.isFetching ||
      queryProgress.isLoading ||
      queryProgress.isFetching ||
      queryReport.isLoading ||
      queryReport.isFetching,
    [
      query.isLoading,
      query.isFetching,
      queryProgress.isLoading,
      queryProgress.isFetching,
      queryReport.isLoading,
      queryReport.isFetching
    ]
  );
  return (
    <InspectionContext.Provider
      value={{
        // inspection: query
        inspection: query?.data,
        report: queryReport?.data,
        loading: loading,
        progress: queryProgress?.data as unknown as InspectionReportProgress
      }}
    >
      <Spin spinning={query.isLoading || query.isFetching}>{children}</Spin>
    </InspectionContext.Provider>
  );
};

export { InspectionContext, InspectionProvider };
